import React from 'react'

import ChooseServicePlanContainer from 'src/containers/AutomaticPlan/ChooseServicePlan'

const ChooseServicePlanPage: React.FC = () => {
  return <ChooseServicePlanContainer />
}

export const PATH = '/automatic-plan/choose-service-plan' as const
export default ChooseServicePlanPage
